import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import Lottie from "lottie-react";
import animation1 from "../assests/animations/animation-1.json";
import animation2 from "../assests/animations/animation-2.json";
import animation3 from "../assests/animations/animation-3.json";

interface LoadingModalProps {
  currentStepMessage: string;
}

const LoadingModal: React.FC<LoadingModalProps> = ({ currentStepMessage }) => {
  const { t } = useTranslation();
  const animations = useMemo(() => [animation1, animation2, animation3], []);
  const [index, setIndex] = useState<number>(0);

  useEffect(() => {
    const id = setInterval(() => {
      setIndex(prev => (prev + 1) % animations.length);
    }, 1800);
    return () => clearInterval(id);
  }, [animations.length]);

  // Show default message if no currentStepMessage is provided
  const displayMessage = currentStepMessage || t("analyzer.analyses_in_progress");

  return (
    <div className="w-full h-full flex items-center justify-center">
      <div className="bg-white p-4 max-w-md w-full mx-4 flex flex-col items-center justify-center">
        <div className="w-[260px] h-[260px]">
          <Lottie animationData={animations[index] as any} loop autoplay />
        </div>
        <div className="text-center text-gray-700">{displayMessage}</div>
      </div>
    </div>
  );
};

export default LoadingModal;
